import React from 'react';
import PropTypes from 'prop-types';

import { useFormContext } from 'react-hook-form';

import { generateStyle } from '../helpers/styles';
import { maskInput } from '../helpers/mask';

/**
* Custom text element
* 
* @param {object}   props
* @param {string}   props.label        - Upper label
* @param {string}   props.name         - Component name
* @param {number}   props.width        - Component width
* @param {string}   props.mode         - The input mode (text, password, search etc)
* @param {string}   props.keyboard     - The input keyboard for mobile devices (numeric, tel, email etc)
* @param {array}    props.mask         - Masks array
* @param {string}   props.defaultValue - Initial value for the input
* @param {Function} props.onFocus      - Handler for event
* @param {Function} props.onBlur       - Handler for event
* @param {Function} props.onChange     - Handler for event
* @param {string}   props.placeholder  - Input placeholder
* @param {string}   props.highlight    - Input highlight
* @param {Object}   props.validation   - Validation rules
* @param {boolean}  props.loading      - Shows/Hides input loader
*/
const TextInput = (props) => {
  const {
    label,
    name,
    width,
    mode,
    keyboard,
    mask,
    defaultValue,
    onFocus,
    onBlur,
    onChange,
    placeholder,
    highlight,
    validation,
    loading
  } = props;
  
  const { register, errors, setValue, formState } = useFormContext();
  const maskValue = (value) => maskInput(mask, value);
  const classes = generateStyle('input', width, formState.touched[name], errors[name], highlight);
  
  const onInputBlur = (event) => (onBlur && onBlur(name, event.currentTarget.value));
  const onValueChange = (event) => {
    const typedValue = maskValue(event.currentTarget.value);
    setValue(name, typedValue);

    onChange && onChange(name, typedValue);
    onFocus && onFocus(name, typedValue);
  };
  return (
    <label className={classes}>
      <span className='input__label'>
        {label}
      </span>
      <input
        type={(mode ? mode : 'text')}
        className='input__element'
        name={name}
        placeholder={placeholder}
        inputMode={keyboard}
        defaultValue={defaultValue}
        onBlur={onInputBlur}
        onChange={onValueChange}
        onFocus={onValueChange}
        ref={register(validation)}
      />
      {errors[name] && <span className='input__error'>{errors[name].message}</span>}
      {loading && <div className='spinner'><div className='child'></div></div>}
    </label>
  );
}
TextInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  mode: PropTypes.string,
  keyboard: PropTypes.string,
  mask: PropTypes.array,
  defaultValue: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  highlight: PropTypes.string,
  validation: PropTypes.object,
  loading: PropTypes.bool
}
export default TextInput;